export default {
  farmSelected: null,
};
